import { NgModule, ModuleWithProviders, Optional, SkipSelf } from '@angular/core';
import { Ng2StompService } from './ng2-stomp.service';


export class Ng2StompModule {
	static forRoot(): ModuleWithProviders {
		return {
			ngModule: Ng2StompModule,
			providers: [Ng2StompService]
		}
	}
	constructor(   parentModule: Ng2StompModule) {
		if (parentModule) {
			throw new Error(
				'Ng2StompModule is already loaded. Import it in the AppModule only');
		}
	}
static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
	imports: [],
	providers: [
	]
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: Ng2StompModule, decorators: [{ type: Optional }, { type: SkipSelf }, ]},
];
}
interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
